export class Controller {

    /** @ngInject */
    constructor($translate) {
        this.$translate = $translate;
    }

    $onInit() {
    }

    templateUrl() {
        return require(`./sms-credit-${this.$translate.use()}.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/sms-credit/sms-credit.controller.js